import React from "react";
//#region types
import { PrintStandardResultReportProps } from "models/propTypes/accountingPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";
//#endregion
//#region components
import { NestedTablePrint } from "components/common";
import useFinancialReportRow from "../.././hooks/useFinancialReportRow";
//#endregion
import { DateHelper, LocalizationHelperInstance, FinancialReportHelper } from "utils/helpers";

const PrintStandardResultReport: React.FC<PrintStandardResultReportProps> = (props) => {
  const {
    title,
    subtitle,
    getRange,
    result,
    amountFormatter,
    differenceFormatter,
    amountHeaderDescription,
    showAccountNumber,
    hideAverageMonthAndDifference,
  } = props;

  const { descriptionFormatter } = useFinancialReportRow(showAccountNumber);

  return (
    <NestedTablePrint<
      WintSuperkollAPIModelFinancialReport.FinancialReportRow,
      WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn
    >
      title={title}
      subTitle={subtitle}
      rows={result}
      properties={{
        description: {
          description: TranslationKeys.Common.Name,
          formatter: descriptionFormatter,
        },
      }}
      repeatProperties={{
        key: "columns",
        properties: {
          amount: {
            description: TranslationKeys.Common.Amount,
            formatter: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn) =>
              LocalizationHelperInstance.getFormattedCurrency(amountFormatter(row)?.amount ?? 0, undefined, 0, 0),
            alignment: "right",
          },
          ...(hideAverageMonthAndDifference
            ? {}
            : {
                difference: {
                  description: amountHeaderDescription,
                  formatter: (
                    row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn,
                    rowIndex?: number,
                    depth?: number,
                    repeatIndex?: number,
                    parentRow?: any
                  ) =>
                    LocalizationHelperInstance.getFormattedCurrency(
                      differenceFormatter(row, undefined, undefined, repeatIndex)?.amount ?? 0,
                      undefined,
                      0,
                      0
                    ),
                  alignment: "right",
                },
              }),
        },
        sumNegative: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn) => row.amount > 0,
        filterField: (repeatIndex: number) => {
          const range = getRange(repeatIndex);
          return range ? DateHelper.formatMonthRange(range?.start, range?.end) : "";
        },
      }}
      childrenKey="children"
      rowDisplayType={FinancialReportHelper.getResultReportRowDisplayType}
    />
  );
};

export default PrintStandardResultReport;
